__turbopack_context__.v({
  "Container": "P1SkMG_Container",
  "HelperText": "P1SkMG_HelperText",
  "Label": "P1SkMG_Label",
  "Switch": "P1SkMG_Switch",
  "SwitchWrap": "P1SkMG_SwitchWrap",
  "TextContent": "P1SkMG_TextContent",
  "Thumb": "P1SkMG_Thumb",
  "checkIcon": "P1SkMG_checkIcon",
  "closeIcon": "P1SkMG_closeIcon",
  "dot": "P1SkMG_dot",
  "secondary": "P1SkMG_secondary",
});
